import React from 'react'
import PropTypes from 'prop-types'
import LoginForm from './LoginForm'
import {Redirect} from 'react-router-dom'
import {AuthContext} from './Auth'
import withLogin from './withLogin'

export default withLogin(LoginForm)



